import AlternativeSelect from 'components/AlternativeSelect/AlternativeSelect';
import React, { useEffect, useState, useRef } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/payments/billingPeriodFilterStyle';
import { makeStyles } from '@material-ui/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Datetime from 'react-datetime';
import { TextField } from '@material-ui/core';
import moment, { Moment } from 'moment';
import { BodySBold, CaptionLight } from 'components/Typography/Typography';
import { now } from 'utils/date/getDate';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { BillingDateSelector } from './BillingDateSelector';
import { getBOMLabels } from 'redux/modules/dynamicLabels/selectors';
import { useSelector } from 'react-redux';
import { Period } from 'views/PaymentRequestStatusBOM';
import { DATE_MONTH_YEAR, MONTH_YEAR } from '../../../constants';
import { AlternativeSelectWrapper } from 'views/common/AlternativeSelectWrapper';
import { dynamicTranslate } from 'components/Translation';

// @ts-ignore
const useStyles = makeStyles(styles);
function TabPanel(props: any) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && (
				<Box p={3}>
					<Typography>{children}</Typography>
				</Box>
			)}
		</div>
	);
}

function a11yProps(index: any) {
	return {
		id: `simple-tab-${index}`,
		'aria-controls': `simple-tabpanel-${index}`,
	};
}

interface IBillingPeriod {
	appliedFilters: types.redux.numbers.MyBillsFilters;
	setAppliedFilters: Function;
}

export const BillingPeriod = ({ appliedFilters, setAppliedFilters }: IBillingPeriod) => {
	const labels = useSelector(getBOMLabels);
	const billsListLabels = labels?.billsListLabels || {};
	const [value, setValue] = React.useState(0);
	const handleChange = (event: any, newValue: any) => {
		setValue(newValue);
		setBillPeriod('');
		setAppliedFilters({
			...appliedFilters,
			billingPeriod: {
				...appliedFilters.billingPeriod,
				period: '',
			},
		});
	};
	const searchingLimit = moment().subtract(billsListLabels.billsSearchingLimit, 'months');

	moment.locale('en', {
		week: {
			dow: 0,
		},
	});
	const [openDatePicker, setOpenDatePicker] = useState(false);
	const [startDateSelected, setStartDateSelected] = useState(false);
	const [endDateSelected, setEndDateSelected] = useState(false);
	const [startDate, setStartDate] = useState(
		moment(now)
			.subtract(billsListLabels.billsSearchingLimit, 'months')
			.format(DATE_MONTH_YEAR)
	);
	const [endDate, setEndDate] = useState(moment(now).format(DATE_MONTH_YEAR));
	const [showAlternatiiveSelectChild, setShowAlternatiiveSelectChild] = useState(false);
	const [billPeriod, setBillPeriod] = useState('');

	const [altSelValue, setAltSelValue] = useState(
		`${moment(now)
			.subtract(billsListLabels.billsSearchingLimit, 'months')
			.format(MONTH_YEAR)} - ${moment(now).format(MONTH_YEAR)}`
	);
	const [dates, setDates] = useState<Period>({
		startDate: moment(now).subtract(billsListLabels.billsSearchingLimit, 'months'),
		endDate: moment().endOf('day'),
	});
	const classes = useStyles();
	const targetRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		setAppliedFilters({
			...appliedFilters,
			billingPeriod: {
				startDate: dates.startDate,
				endDate: dates.endDate,
				period: billPeriod,
			},
		});
	}, [altSelValue]);
	useEffect(() => {
		if (appliedFilters.billingPeriod.period) {
			setValue(1);
		}
		const { startDate, endDate } = appliedFilters?.billingPeriod;

		setDates({ ...dates, ...(startDate && { startDate }), ...(endDate && { endDate }) });

		setAltSelValue(`${dates.startDate.format(DATE_MONTH_YEAR)} - ${dates.endDate.format(DATE_MONTH_YEAR)}`);
	}, [appliedFilters]);
	return (
		<AlternativeSelectWrapper
			showBorder
			dropdownIcon={<ArrowDropDownIcon />}
			renderChildren={showAlternatiiveSelectChild}
			setRenderChildren={setShowAlternatiiveSelectChild}
			type="sm"
			id="period-select"
			label={billsListLabels.billingPeriodFilter}
			value={<div>{altSelValue}</div>}
			onClick={() => {
				setShowAlternatiiveSelectChild(true);
			}}
			items={[]}
			showItems={false}
			selectedItems={[]}
			withHorizontalPadding
		>
			<div className={classes.billPeriodWrapper} id="billPeriodId">
				<AppBar position="static" color="default">
					<Tabs
						value={value}
						onChange={handleChange}
						aria-label="simple tabs example"
						indicatorColor="primary"
						textColor="primary"
						variant="fullWidth"
					>
						<Tab label={billsListLabels.dateRange} {...a11yProps(0)} />
						<Tab label={billsListLabels.billPeriod} {...a11yProps(1)} />
					</Tabs>
				</AppBar>
				<TabPanel value={value} index={0}>
					<BodySBold>
						{dynamicTranslate(billsListLabels.selectUpto, billsListLabels.billsSearchingLimit)}
					</BodySBold>
					<BillingDateSelector
						dates={dates}
						setDates={setDates}
						startDateSelected={startDateSelected}
						endDateSelected={endDateSelected}
						setEndDateSelected={setEndDateSelected}
						setStartDateSelected={setStartDateSelected}
						openDatePicker={openDatePicker}
						setOpenDatePicker={setOpenDatePicker}
						setAltSelValue={setAltSelValue}
					/>
					<CaptionLight customClassName={classes.caption}>
						{dynamicTranslate(billsListLabels.billPeriodNote, billsListLabels.billsSearchingLimit)}
					</CaptionLight>
				</TabPanel>
				<TabPanel value={value} index={1}>
					<div className={classes.billMonthWrapper}>
						<BodySBold>{billsListLabels.billingMonth}</BodySBold>
						<div className={classes.dateInputWrapper}>
							<TextField
								onClick={() => {
									setOpenDatePicker(true);
								}}
								value={billPeriod}
								onChange={() => {
									setBillPeriod('');
								}}
								data-testId="bill-period"
							/>
							<Datetime
								closeOnSelect={true}
								renderDay={(props, currentDate) => (
									<td {...props}>
										<div className={classes.cell}>{currentDate.date()}</div>
									</td>
								)}
								open={openDatePicker}
								onChange={(e: any) => {
									setOpenDatePicker(false);
									setStartDate('');
									setEndDate('');
									setBillPeriod(e.format && e.format('MMMM YYYY'));
									setAppliedFilters({
										...appliedFilters,
										billingPeriod: {
											...appliedFilters.billingPeriod,
											period: e.format && e.format('MMMM YYYY'),
										},
									});
								}}
								timeFormat={false}
								viewMode={'months'}
								dateFormat={'MMM YYYY'}
								isValidDate={(currentDate) => {
									return (
										currentDate.isAfter(searchingLimit, 'months') && currentDate.isSameOrBefore(now)
									);
								}}
							/>
						</div>
					</div>
				</TabPanel>
			</div>
		</AlternativeSelectWrapper>
	);
};
